import { render, staticRenderFns } from "./picker-slot.vue?vue&type=template&id=bf0f2630&"
import script from "./picker-slot.vue?vue&type=script&lang=js&"
export * from "./picker-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports